import { a as wr } from "./_commonjsHelpers-B52_cu2H.js";
var ur = {}, H = {}, Ir;
function wt() {
  if (Ir) return H;
  Ir = 1, H.byteLength = f, H.toByteArray = w, H.fromByteArray = E;
  for (var e = [], i = [], n = typeof Uint8Array < "u" ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = 0, s = a.length; h < s; ++h)
    e[h] = a[h], i[a.charCodeAt(h)] = h;
  i[45] = 62, i[95] = 63;
  function c(d) {
    var g = d.length;
    if (g % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var _ = d.indexOf("=");
    _ === -1 && (_ = g);
    var A = _ === g ? 0 : 4 - _ % 4;
    return [_, A];
  }
  function f(d) {
    var g = c(d), _ = g[0], A = g[1];
    return (_ + A) * 3 / 4 - A;
  }
  function m(d, g, _) {
    return (g + _) * 3 / 4 - _;
  }
  function w(d) {
    var g, _ = c(d), A = _[0], x = _[1], S = new n(m(d, A, x)), C = 0, F = x > 0 ? A - 4 : A, M;
    for (M = 0; M < F; M += 4)
      g = i[d.charCodeAt(M)] << 18 | i[d.charCodeAt(M + 1)] << 12 | i[d.charCodeAt(M + 2)] << 6 | i[d.charCodeAt(M + 3)], S[C++] = g >> 16 & 255, S[C++] = g >> 8 & 255, S[C++] = g & 255;
    return x === 2 && (g = i[d.charCodeAt(M)] << 2 | i[d.charCodeAt(M + 1)] >> 4, S[C++] = g & 255), x === 1 && (g = i[d.charCodeAt(M)] << 10 | i[d.charCodeAt(M + 1)] << 4 | i[d.charCodeAt(M + 2)] >> 2, S[C++] = g >> 8 & 255, S[C++] = g & 255), S;
  }
  function v(d) {
    return e[d >> 18 & 63] + e[d >> 12 & 63] + e[d >> 6 & 63] + e[d & 63];
  }
  function b(d, g, _) {
    for (var A, x = [], S = g; S < _; S += 3)
      A = (d[S] << 16 & 16711680) + (d[S + 1] << 8 & 65280) + (d[S + 2] & 255), x.push(v(A));
    return x.join("");
  }
  function E(d) {
    for (var g, _ = d.length, A = _ % 3, x = [], S = 16383, C = 0, F = _ - A; C < F; C += S)
      x.push(b(d, C, C + S > F ? F : C + S));
    return A === 1 ? (g = d[_ - 1], x.push(
      e[g >> 2] + e[g << 4 & 63] + "=="
    )) : A === 2 && (g = (d[_ - 2] << 8) + d[_ - 1], x.push(
      e[g >> 10] + e[g >> 4 & 63] + e[g << 2 & 63] + "="
    )), x.join("");
  }
  return H;
}
var nr = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var Ur;
function vt() {
  return Ur || (Ur = 1, nr.read = function(e, i, n, a, h) {
    var s, c, f = h * 8 - a - 1, m = (1 << f) - 1, w = m >> 1, v = -7, b = n ? h - 1 : 0, E = n ? -1 : 1, d = e[i + b];
    for (b += E, s = d & (1 << -v) - 1, d >>= -v, v += f; v > 0; s = s * 256 + e[i + b], b += E, v -= 8)
      ;
    for (c = s & (1 << -v) - 1, s >>= -v, v += a; v > 0; c = c * 256 + e[i + b], b += E, v -= 8)
      ;
    if (s === 0)
      s = 1 - w;
    else {
      if (s === m)
        return c ? NaN : (d ? -1 : 1) * (1 / 0);
      c = c + Math.pow(2, a), s = s - w;
    }
    return (d ? -1 : 1) * c * Math.pow(2, s - a);
  }, nr.write = function(e, i, n, a, h, s) {
    var c, f, m, w = s * 8 - h - 1, v = (1 << w) - 1, b = v >> 1, E = h === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = a ? 0 : s - 1, g = a ? 1 : -1, _ = i < 0 || i === 0 && 1 / i < 0 ? 1 : 0;
    for (i = Math.abs(i), isNaN(i) || i === 1 / 0 ? (f = isNaN(i) ? 1 : 0, c = v) : (c = Math.floor(Math.log(i) / Math.LN2), i * (m = Math.pow(2, -c)) < 1 && (c--, m *= 2), c + b >= 1 ? i += E / m : i += E * Math.pow(2, 1 - b), i * m >= 2 && (c++, m /= 2), c + b >= v ? (f = 0, c = v) : c + b >= 1 ? (f = (i * m - 1) * Math.pow(2, h), c = c + b) : (f = i * Math.pow(2, b - 1) * Math.pow(2, h), c = 0)); h >= 8; e[n + d] = f & 255, d += g, f /= 256, h -= 8)
      ;
    for (c = c << h | f, w += h; w > 0; e[n + d] = c & 255, d += g, c /= 256, w -= 8)
      ;
    e[n + d - g] |= _ * 128;
  }), nr;
}
var fr, Dr;
function mt() {
  if (Dr) return fr;
  Dr = 1;
  var e = {}.toString;
  return fr = Array.isArray || function(i) {
    return e.call(i) == "[object Array]";
  }, fr;
}
var Cr;
function dt() {
  return Cr || (Cr = 1, function(e) {
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <http://feross.org>
     * @license  MIT
     */
    var i = wt(), n = vt(), a = mt();
    e.Buffer = f, e.SlowBuffer = x, e.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = globalThis.TYPED_ARRAY_SUPPORT !== void 0 ? globalThis.TYPED_ARRAY_SUPPORT : h(), e.kMaxLength = s();
    function h() {
      try {
        var o = new Uint8Array(1);
        return o.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
          return 42;
        } }, o.foo() === 42 && // typed array instances can be augmented
        typeof o.subarray == "function" && // chrome 9-10 lack `subarray`
        o.subarray(1, 1).byteLength === 0;
      } catch {
        return !1;
      }
    }
    function s() {
      return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function c(o, r) {
      if (s() < r)
        throw new RangeError("Invalid typed array length");
      return f.TYPED_ARRAY_SUPPORT ? (o = new Uint8Array(r), o.__proto__ = f.prototype) : (o === null && (o = new f(r)), o.length = r), o;
    }
    function f(o, r, t) {
      if (!f.TYPED_ARRAY_SUPPORT && !(this instanceof f))
        return new f(o, r, t);
      if (typeof o == "number") {
        if (typeof r == "string")
          throw new Error(
            "If encoding is specified then the first argument must be a string"
          );
        return b(this, o);
      }
      return m(this, o, r, t);
    }
    f.poolSize = 8192, f._augment = function(o) {
      return o.__proto__ = f.prototype, o;
    };
    function m(o, r, t, u) {
      if (typeof r == "number")
        throw new TypeError('"value" argument must not be a number');
      return typeof ArrayBuffer < "u" && r instanceof ArrayBuffer ? g(o, r, t, u) : typeof r == "string" ? E(o, r, t) : _(o, r);
    }
    f.from = function(o, r, t) {
      return m(null, o, r, t);
    }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
      value: null,
      configurable: !0
    }));
    function w(o) {
      if (typeof o != "number")
        throw new TypeError('"size" argument must be a number');
      if (o < 0)
        throw new RangeError('"size" argument must not be negative');
    }
    function v(o, r, t, u) {
      return w(r), r <= 0 ? c(o, r) : t !== void 0 ? typeof u == "string" ? c(o, r).fill(t, u) : c(o, r).fill(t) : c(o, r);
    }
    f.alloc = function(o, r, t) {
      return v(null, o, r, t);
    };
    function b(o, r) {
      if (w(r), o = c(o, r < 0 ? 0 : A(r) | 0), !f.TYPED_ARRAY_SUPPORT)
        for (var t = 0; t < r; ++t)
          o[t] = 0;
      return o;
    }
    f.allocUnsafe = function(o) {
      return b(null, o);
    }, f.allocUnsafeSlow = function(o) {
      return b(null, o);
    };
    function E(o, r, t) {
      if ((typeof t != "string" || t === "") && (t = "utf8"), !f.isEncoding(t))
        throw new TypeError('"encoding" must be a valid string encoding');
      var u = S(r, t) | 0;
      o = c(o, u);
      var l = o.write(r, t);
      return l !== u && (o = o.slice(0, l)), o;
    }
    function d(o, r) {
      var t = r.length < 0 ? 0 : A(r.length) | 0;
      o = c(o, t);
      for (var u = 0; u < t; u += 1)
        o[u] = r[u] & 255;
      return o;
    }
    function g(o, r, t, u) {
      if (r.byteLength, t < 0 || r.byteLength < t)
        throw new RangeError("'offset' is out of bounds");
      if (r.byteLength < t + (u || 0))
        throw new RangeError("'length' is out of bounds");
      return t === void 0 && u === void 0 ? r = new Uint8Array(r) : u === void 0 ? r = new Uint8Array(r, t) : r = new Uint8Array(r, t, u), f.TYPED_ARRAY_SUPPORT ? (o = r, o.__proto__ = f.prototype) : o = d(o, r), o;
    }
    function _(o, r) {
      if (f.isBuffer(r)) {
        var t = A(r.length) | 0;
        return o = c(o, t), o.length === 0 || r.copy(o, 0, 0, t), o;
      }
      if (r) {
        if (typeof ArrayBuffer < "u" && r.buffer instanceof ArrayBuffer || "length" in r)
          return typeof r.length != "number" || yt(r.length) ? c(o, 0) : d(o, r);
        if (r.type === "Buffer" && a(r.data))
          return d(o, r.data);
      }
      throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }
    function A(o) {
      if (o >= s())
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
      return o | 0;
    }
    function x(o) {
      return +o != o && (o = 0), f.alloc(+o);
    }
    f.isBuffer = function(r) {
      return !!(r != null && r._isBuffer);
    }, f.compare = function(r, t) {
      if (!f.isBuffer(r) || !f.isBuffer(t))
        throw new TypeError("Arguments must be Buffers");
      if (r === t) return 0;
      for (var u = r.length, l = t.length, p = 0, y = Math.min(u, l); p < y; ++p)
        if (r[p] !== t[p]) {
          u = r[p], l = t[p];
          break;
        }
      return u < l ? -1 : l < u ? 1 : 0;
    }, f.isEncoding = function(r) {
      switch (String(r).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, f.concat = function(r, t) {
      if (!a(r))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (r.length === 0)
        return f.alloc(0);
      var u;
      if (t === void 0)
        for (t = 0, u = 0; u < r.length; ++u)
          t += r[u].length;
      var l = f.allocUnsafe(t), p = 0;
      for (u = 0; u < r.length; ++u) {
        var y = r[u];
        if (!f.isBuffer(y))
          throw new TypeError('"list" argument must be an Array of Buffers');
        y.copy(l, p), p += y.length;
      }
      return l;
    };
    function S(o, r) {
      if (f.isBuffer(o))
        return o.length;
      if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(o) || o instanceof ArrayBuffer))
        return o.byteLength;
      typeof o != "string" && (o = "" + o);
      var t = o.length;
      if (t === 0) return 0;
      for (var u = !1; ; )
        switch (r) {
          case "ascii":
          case "latin1":
          case "binary":
            return t;
          case "utf8":
          case "utf-8":
          case void 0:
            return tr(o).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return t * 2;
          case "hex":
            return t >>> 1;
          case "base64":
            return xr(o).length;
          default:
            if (u) return tr(o).length;
            r = ("" + r).toLowerCase(), u = !0;
        }
    }
    f.byteLength = S;
    function C(o, r, t) {
      var u = !1;
      if ((r === void 0 || r < 0) && (r = 0), r > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, r >>>= 0, t <= r))
        return "";
      for (o || (o = "utf8"); ; )
        switch (o) {
          case "hex":
            return ut(this, r, t);
          case "utf8":
          case "utf-8":
            return br(this, r, t);
          case "ascii":
            return nt(this, r, t);
          case "latin1":
          case "binary":
            return ot(this, r, t);
          case "base64":
            return et(this, r, t);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ft(this, r, t);
          default:
            if (u) throw new TypeError("Unknown encoding: " + o);
            o = (o + "").toLowerCase(), u = !0;
        }
    }
    f.prototype._isBuffer = !0;
    function F(o, r, t) {
      var u = o[r];
      o[r] = o[t], o[t] = u;
    }
    f.prototype.swap16 = function() {
      var r = this.length;
      if (r % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var t = 0; t < r; t += 2)
        F(this, t, t + 1);
      return this;
    }, f.prototype.swap32 = function() {
      var r = this.length;
      if (r % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var t = 0; t < r; t += 4)
        F(this, t, t + 3), F(this, t + 1, t + 2);
      return this;
    }, f.prototype.swap64 = function() {
      var r = this.length;
      if (r % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var t = 0; t < r; t += 8)
        F(this, t, t + 7), F(this, t + 1, t + 6), F(this, t + 2, t + 5), F(this, t + 3, t + 4);
      return this;
    }, f.prototype.toString = function() {
      var r = this.length | 0;
      return r === 0 ? "" : arguments.length === 0 ? br(this, 0, r) : C.apply(this, arguments);
    }, f.prototype.equals = function(r) {
      if (!f.isBuffer(r)) throw new TypeError("Argument must be a Buffer");
      return this === r ? !0 : f.compare(this, r) === 0;
    }, f.prototype.inspect = function() {
      var r = "", t = e.INSPECT_MAX_BYTES;
      return this.length > 0 && (r = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (r += " ... ")), "<Buffer " + r + ">";
    }, f.prototype.compare = function(r, t, u, l, p) {
      if (!f.isBuffer(r))
        throw new TypeError("Argument must be a Buffer");
      if (t === void 0 && (t = 0), u === void 0 && (u = r ? r.length : 0), l === void 0 && (l = 0), p === void 0 && (p = this.length), t < 0 || u > r.length || l < 0 || p > this.length)
        throw new RangeError("out of range index");
      if (l >= p && t >= u)
        return 0;
      if (l >= p)
        return -1;
      if (t >= u)
        return 1;
      if (t >>>= 0, u >>>= 0, l >>>= 0, p >>>= 0, this === r) return 0;
      for (var y = p - l, B = u - t, R = Math.min(y, B), I = this.slice(l, p), P = r.slice(t, u), U = 0; U < R; ++U)
        if (I[U] !== P[U]) {
          y = I[U], B = P[U];
          break;
        }
      return y < B ? -1 : B < y ? 1 : 0;
    };
    function M(o, r, t, u, l) {
      if (o.length === 0) return -1;
      if (typeof t == "string" ? (u = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, isNaN(t) && (t = l ? 0 : o.length - 1), t < 0 && (t = o.length + t), t >= o.length) {
        if (l) return -1;
        t = o.length - 1;
      } else if (t < 0)
        if (l) t = 0;
        else return -1;
      if (typeof r == "string" && (r = f.from(r, u)), f.isBuffer(r))
        return r.length === 0 ? -1 : gr(o, r, t, u, l);
      if (typeof r == "number")
        return r = r & 255, f.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? l ? Uint8Array.prototype.indexOf.call(o, r, t) : Uint8Array.prototype.lastIndexOf.call(o, r, t) : gr(o, [r], t, u, l);
      throw new TypeError("val must be string, number or Buffer");
    }
    function gr(o, r, t, u, l) {
      var p = 1, y = o.length, B = r.length;
      if (u !== void 0 && (u = String(u).toLowerCase(), u === "ucs2" || u === "ucs-2" || u === "utf16le" || u === "utf-16le")) {
        if (o.length < 2 || r.length < 2)
          return -1;
        p = 2, y /= 2, B /= 2, t /= 2;
      }
      function R(Sr, Rr) {
        return p === 1 ? Sr[Rr] : Sr.readUInt16BE(Rr * p);
      }
      var I;
      if (l) {
        var P = -1;
        for (I = t; I < y; I++)
          if (R(o, I) === R(r, P === -1 ? 0 : I - P)) {
            if (P === -1 && (P = I), I - P + 1 === B) return P * p;
          } else
            P !== -1 && (I -= I - P), P = -1;
      } else
        for (t + B > y && (t = y - B), I = t; I >= 0; I--) {
          for (var U = !0, ir = 0; ir < B; ir++)
            if (R(o, I + ir) !== R(r, ir)) {
              U = !1;
              break;
            }
          if (U) return I;
        }
      return -1;
    }
    f.prototype.includes = function(r, t, u) {
      return this.indexOf(r, t, u) !== -1;
    }, f.prototype.indexOf = function(r, t, u) {
      return M(this, r, t, u, !0);
    }, f.prototype.lastIndexOf = function(r, t, u) {
      return M(this, r, t, u, !1);
    };
    function Xr(o, r, t, u) {
      t = Number(t) || 0;
      var l = o.length - t;
      u ? (u = Number(u), u > l && (u = l)) : u = l;
      var p = r.length;
      if (p % 2 !== 0) throw new TypeError("Invalid hex string");
      u > p / 2 && (u = p / 2);
      for (var y = 0; y < u; ++y) {
        var B = parseInt(r.substr(y * 2, 2), 16);
        if (isNaN(B)) return y;
        o[t + y] = B;
      }
      return y;
    }
    function zr(o, r, t, u) {
      return er(tr(r, o.length - t), o, t, u);
    }
    function _r(o, r, t, u) {
      return er(lt(r), o, t, u);
    }
    function Qr(o, r, t, u) {
      return _r(o, r, t, u);
    }
    function rt(o, r, t, u) {
      return er(xr(r), o, t, u);
    }
    function tt(o, r, t, u) {
      return er(pt(r, o.length - t), o, t, u);
    }
    f.prototype.write = function(r, t, u, l) {
      if (t === void 0)
        l = "utf8", u = this.length, t = 0;
      else if (u === void 0 && typeof t == "string")
        l = t, u = this.length, t = 0;
      else if (isFinite(t))
        t = t | 0, isFinite(u) ? (u = u | 0, l === void 0 && (l = "utf8")) : (l = u, u = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var p = this.length - t;
      if ((u === void 0 || u > p) && (u = p), r.length > 0 && (u < 0 || t < 0) || t > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      l || (l = "utf8");
      for (var y = !1; ; )
        switch (l) {
          case "hex":
            return Xr(this, r, t, u);
          case "utf8":
          case "utf-8":
            return zr(this, r, t, u);
          case "ascii":
            return _r(this, r, t, u);
          case "latin1":
          case "binary":
            return Qr(this, r, t, u);
          case "base64":
            return rt(this, r, t, u);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return tt(this, r, t, u);
          default:
            if (y) throw new TypeError("Unknown encoding: " + l);
            l = ("" + l).toLowerCase(), y = !0;
        }
    }, f.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function et(o, r, t) {
      return r === 0 && t === o.length ? i.fromByteArray(o) : i.fromByteArray(o.slice(r, t));
    }
    function br(o, r, t) {
      t = Math.min(o.length, t);
      for (var u = [], l = r; l < t; ) {
        var p = o[l], y = null, B = p > 239 ? 4 : p > 223 ? 3 : p > 191 ? 2 : 1;
        if (l + B <= t) {
          var R, I, P, U;
          switch (B) {
            case 1:
              p < 128 && (y = p);
              break;
            case 2:
              R = o[l + 1], (R & 192) === 128 && (U = (p & 31) << 6 | R & 63, U > 127 && (y = U));
              break;
            case 3:
              R = o[l + 1], I = o[l + 2], (R & 192) === 128 && (I & 192) === 128 && (U = (p & 15) << 12 | (R & 63) << 6 | I & 63, U > 2047 && (U < 55296 || U > 57343) && (y = U));
              break;
            case 4:
              R = o[l + 1], I = o[l + 2], P = o[l + 3], (R & 192) === 128 && (I & 192) === 128 && (P & 192) === 128 && (U = (p & 15) << 18 | (R & 63) << 12 | (I & 63) << 6 | P & 63, U > 65535 && U < 1114112 && (y = U));
          }
        }
        y === null ? (y = 65533, B = 1) : y > 65535 && (y -= 65536, u.push(y >>> 10 & 1023 | 55296), y = 56320 | y & 1023), u.push(y), l += B;
      }
      return it(u);
    }
    var Er = 4096;
    function it(o) {
      var r = o.length;
      if (r <= Er)
        return String.fromCharCode.apply(String, o);
      for (var t = "", u = 0; u < r; )
        t += String.fromCharCode.apply(
          String,
          o.slice(u, u += Er)
        );
      return t;
    }
    function nt(o, r, t) {
      var u = "";
      t = Math.min(o.length, t);
      for (var l = r; l < t; ++l)
        u += String.fromCharCode(o[l] & 127);
      return u;
    }
    function ot(o, r, t) {
      var u = "";
      t = Math.min(o.length, t);
      for (var l = r; l < t; ++l)
        u += String.fromCharCode(o[l]);
      return u;
    }
    function ut(o, r, t) {
      var u = o.length;
      (!r || r < 0) && (r = 0), (!t || t < 0 || t > u) && (t = u);
      for (var l = "", p = r; p < t; ++p)
        l += ct(o[p]);
      return l;
    }
    function ft(o, r, t) {
      for (var u = o.slice(r, t), l = "", p = 0; p < u.length; p += 2)
        l += String.fromCharCode(u[p] + u[p + 1] * 256);
      return l;
    }
    f.prototype.slice = function(r, t) {
      var u = this.length;
      r = ~~r, t = t === void 0 ? u : ~~t, r < 0 ? (r += u, r < 0 && (r = 0)) : r > u && (r = u), t < 0 ? (t += u, t < 0 && (t = 0)) : t > u && (t = u), t < r && (t = r);
      var l;
      if (f.TYPED_ARRAY_SUPPORT)
        l = this.subarray(r, t), l.__proto__ = f.prototype;
      else {
        var p = t - r;
        l = new f(p, void 0);
        for (var y = 0; y < p; ++y)
          l[y] = this[y + r];
      }
      return l;
    };
    function D(o, r, t) {
      if (o % 1 !== 0 || o < 0) throw new RangeError("offset is not uint");
      if (o + r > t) throw new RangeError("Trying to access beyond buffer length");
    }
    f.prototype.readUIntLE = function(r, t, u) {
      r = r | 0, t = t | 0, u || D(r, t, this.length);
      for (var l = this[r], p = 1, y = 0; ++y < t && (p *= 256); )
        l += this[r + y] * p;
      return l;
    }, f.prototype.readUIntBE = function(r, t, u) {
      r = r | 0, t = t | 0, u || D(r, t, this.length);
      for (var l = this[r + --t], p = 1; t > 0 && (p *= 256); )
        l += this[r + --t] * p;
      return l;
    }, f.prototype.readUInt8 = function(r, t) {
      return t || D(r, 1, this.length), this[r];
    }, f.prototype.readUInt16LE = function(r, t) {
      return t || D(r, 2, this.length), this[r] | this[r + 1] << 8;
    }, f.prototype.readUInt16BE = function(r, t) {
      return t || D(r, 2, this.length), this[r] << 8 | this[r + 1];
    }, f.prototype.readUInt32LE = function(r, t) {
      return t || D(r, 4, this.length), (this[r] | this[r + 1] << 8 | this[r + 2] << 16) + this[r + 3] * 16777216;
    }, f.prototype.readUInt32BE = function(r, t) {
      return t || D(r, 4, this.length), this[r] * 16777216 + (this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3]);
    }, f.prototype.readIntLE = function(r, t, u) {
      r = r | 0, t = t | 0, u || D(r, t, this.length);
      for (var l = this[r], p = 1, y = 0; ++y < t && (p *= 256); )
        l += this[r + y] * p;
      return p *= 128, l >= p && (l -= Math.pow(2, 8 * t)), l;
    }, f.prototype.readIntBE = function(r, t, u) {
      r = r | 0, t = t | 0, u || D(r, t, this.length);
      for (var l = t, p = 1, y = this[r + --l]; l > 0 && (p *= 256); )
        y += this[r + --l] * p;
      return p *= 128, y >= p && (y -= Math.pow(2, 8 * t)), y;
    }, f.prototype.readInt8 = function(r, t) {
      return t || D(r, 1, this.length), this[r] & 128 ? (255 - this[r] + 1) * -1 : this[r];
    }, f.prototype.readInt16LE = function(r, t) {
      t || D(r, 2, this.length);
      var u = this[r] | this[r + 1] << 8;
      return u & 32768 ? u | 4294901760 : u;
    }, f.prototype.readInt16BE = function(r, t) {
      t || D(r, 2, this.length);
      var u = this[r + 1] | this[r] << 8;
      return u & 32768 ? u | 4294901760 : u;
    }, f.prototype.readInt32LE = function(r, t) {
      return t || D(r, 4, this.length), this[r] | this[r + 1] << 8 | this[r + 2] << 16 | this[r + 3] << 24;
    }, f.prototype.readInt32BE = function(r, t) {
      return t || D(r, 4, this.length), this[r] << 24 | this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3];
    }, f.prototype.readFloatLE = function(r, t) {
      return t || D(r, 4, this.length), n.read(this, r, !0, 23, 4);
    }, f.prototype.readFloatBE = function(r, t) {
      return t || D(r, 4, this.length), n.read(this, r, !1, 23, 4);
    }, f.prototype.readDoubleLE = function(r, t) {
      return t || D(r, 8, this.length), n.read(this, r, !0, 52, 8);
    }, f.prototype.readDoubleBE = function(r, t) {
      return t || D(r, 8, this.length), n.read(this, r, !1, 52, 8);
    };
    function L(o, r, t, u, l, p) {
      if (!f.isBuffer(o)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (r > l || r < p) throw new RangeError('"value" argument is out of bounds');
      if (t + u > o.length) throw new RangeError("Index out of range");
    }
    f.prototype.writeUIntLE = function(r, t, u, l) {
      if (r = +r, t = t | 0, u = u | 0, !l) {
        var p = Math.pow(2, 8 * u) - 1;
        L(this, r, t, u, p, 0);
      }
      var y = 1, B = 0;
      for (this[t] = r & 255; ++B < u && (y *= 256); )
        this[t + B] = r / y & 255;
      return t + u;
    }, f.prototype.writeUIntBE = function(r, t, u, l) {
      if (r = +r, t = t | 0, u = u | 0, !l) {
        var p = Math.pow(2, 8 * u) - 1;
        L(this, r, t, u, p, 0);
      }
      var y = u - 1, B = 1;
      for (this[t + y] = r & 255; --y >= 0 && (B *= 256); )
        this[t + y] = r / B & 255;
      return t + u;
    }, f.prototype.writeUInt8 = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (r = Math.floor(r)), this[t] = r & 255, t + 1;
    };
    function Q(o, r, t, u) {
      r < 0 && (r = 65535 + r + 1);
      for (var l = 0, p = Math.min(o.length - t, 2); l < p; ++l)
        o[t + l] = (r & 255 << 8 * (u ? l : 1 - l)) >>> (u ? l : 1 - l) * 8;
    }
    f.prototype.writeUInt16LE = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = r & 255, this[t + 1] = r >>> 8) : Q(this, r, t, !0), t + 2;
    }, f.prototype.writeUInt16BE = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = r >>> 8, this[t + 1] = r & 255) : Q(this, r, t, !1), t + 2;
    };
    function rr(o, r, t, u) {
      r < 0 && (r = 4294967295 + r + 1);
      for (var l = 0, p = Math.min(o.length - t, 4); l < p; ++l)
        o[t + l] = r >>> (u ? l : 3 - l) * 8 & 255;
    }
    f.prototype.writeUInt32LE = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t + 3] = r >>> 24, this[t + 2] = r >>> 16, this[t + 1] = r >>> 8, this[t] = r & 255) : rr(this, r, t, !0), t + 4;
    }, f.prototype.writeUInt32BE = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[t] = r >>> 24, this[t + 1] = r >>> 16, this[t + 2] = r >>> 8, this[t + 3] = r & 255) : rr(this, r, t, !1), t + 4;
    }, f.prototype.writeIntLE = function(r, t, u, l) {
      if (r = +r, t = t | 0, !l) {
        var p = Math.pow(2, 8 * u - 1);
        L(this, r, t, u, p - 1, -p);
      }
      var y = 0, B = 1, R = 0;
      for (this[t] = r & 255; ++y < u && (B *= 256); )
        r < 0 && R === 0 && this[t + y - 1] !== 0 && (R = 1), this[t + y] = (r / B >> 0) - R & 255;
      return t + u;
    }, f.prototype.writeIntBE = function(r, t, u, l) {
      if (r = +r, t = t | 0, !l) {
        var p = Math.pow(2, 8 * u - 1);
        L(this, r, t, u, p - 1, -p);
      }
      var y = u - 1, B = 1, R = 0;
      for (this[t + y] = r & 255; --y >= 0 && (B *= 256); )
        r < 0 && R === 0 && this[t + y + 1] !== 0 && (R = 1), this[t + y] = (r / B >> 0) - R & 255;
      return t + u;
    }, f.prototype.writeInt8 = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (r = Math.floor(r)), r < 0 && (r = 255 + r + 1), this[t] = r & 255, t + 1;
    }, f.prototype.writeInt16LE = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = r & 255, this[t + 1] = r >>> 8) : Q(this, r, t, !0), t + 2;
    }, f.prototype.writeInt16BE = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[t] = r >>> 8, this[t + 1] = r & 255) : Q(this, r, t, !1), t + 2;
    }, f.prototype.writeInt32LE = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[t] = r & 255, this[t + 1] = r >>> 8, this[t + 2] = r >>> 16, this[t + 3] = r >>> 24) : rr(this, r, t, !0), t + 4;
    }, f.prototype.writeInt32BE = function(r, t, u) {
      return r = +r, t = t | 0, u || L(this, r, t, 4, 2147483647, -2147483648), r < 0 && (r = 4294967295 + r + 1), f.TYPED_ARRAY_SUPPORT ? (this[t] = r >>> 24, this[t + 1] = r >>> 16, this[t + 2] = r >>> 8, this[t + 3] = r & 255) : rr(this, r, t, !1), t + 4;
    };
    function Tr(o, r, t, u, l, p) {
      if (t + u > o.length) throw new RangeError("Index out of range");
      if (t < 0) throw new RangeError("Index out of range");
    }
    function Ar(o, r, t, u, l) {
      return l || Tr(o, r, t, 4), n.write(o, r, t, u, 23, 4), t + 4;
    }
    f.prototype.writeFloatLE = function(r, t, u) {
      return Ar(this, r, t, !0, u);
    }, f.prototype.writeFloatBE = function(r, t, u) {
      return Ar(this, r, t, !1, u);
    };
    function Br(o, r, t, u, l) {
      return l || Tr(o, r, t, 8), n.write(o, r, t, u, 52, 8), t + 8;
    }
    f.prototype.writeDoubleLE = function(r, t, u) {
      return Br(this, r, t, !0, u);
    }, f.prototype.writeDoubleBE = function(r, t, u) {
      return Br(this, r, t, !1, u);
    }, f.prototype.copy = function(r, t, u, l) {
      if (u || (u = 0), !l && l !== 0 && (l = this.length), t >= r.length && (t = r.length), t || (t = 0), l > 0 && l < u && (l = u), l === u || r.length === 0 || this.length === 0) return 0;
      if (t < 0)
        throw new RangeError("targetStart out of bounds");
      if (u < 0 || u >= this.length) throw new RangeError("sourceStart out of bounds");
      if (l < 0) throw new RangeError("sourceEnd out of bounds");
      l > this.length && (l = this.length), r.length - t < l - u && (l = r.length - t + u);
      var p = l - u, y;
      if (this === r && u < t && t < l)
        for (y = p - 1; y >= 0; --y)
          r[y + t] = this[y + u];
      else if (p < 1e3 || !f.TYPED_ARRAY_SUPPORT)
        for (y = 0; y < p; ++y)
          r[y + t] = this[y + u];
      else
        Uint8Array.prototype.set.call(
          r,
          this.subarray(u, u + p),
          t
        );
      return p;
    }, f.prototype.fill = function(r, t, u, l) {
      if (typeof r == "string") {
        if (typeof t == "string" ? (l = t, t = 0, u = this.length) : typeof u == "string" && (l = u, u = this.length), r.length === 1) {
          var p = r.charCodeAt(0);
          p < 256 && (r = p);
        }
        if (l !== void 0 && typeof l != "string")
          throw new TypeError("encoding must be a string");
        if (typeof l == "string" && !f.isEncoding(l))
          throw new TypeError("Unknown encoding: " + l);
      } else typeof r == "number" && (r = r & 255);
      if (t < 0 || this.length < t || this.length < u)
        throw new RangeError("Out of range index");
      if (u <= t)
        return this;
      t = t >>> 0, u = u === void 0 ? this.length : u >>> 0, r || (r = 0);
      var y;
      if (typeof r == "number")
        for (y = t; y < u; ++y)
          this[y] = r;
      else {
        var B = f.isBuffer(r) ? r : tr(new f(r, l).toString()), R = B.length;
        for (y = 0; y < u - t; ++y)
          this[y + t] = B[y % R];
      }
      return this;
    };
    var at = /[^+\/0-9A-Za-z-_]/g;
    function st(o) {
      if (o = ht(o).replace(at, ""), o.length < 2) return "";
      for (; o.length % 4 !== 0; )
        o = o + "=";
      return o;
    }
    function ht(o) {
      return o.trim ? o.trim() : o.replace(/^\s+|\s+$/g, "");
    }
    function ct(o) {
      return o < 16 ? "0" + o.toString(16) : o.toString(16);
    }
    function tr(o, r) {
      r = r || 1 / 0;
      for (var t, u = o.length, l = null, p = [], y = 0; y < u; ++y) {
        if (t = o.charCodeAt(y), t > 55295 && t < 57344) {
          if (!l) {
            if (t > 56319) {
              (r -= 3) > -1 && p.push(239, 191, 189);
              continue;
            } else if (y + 1 === u) {
              (r -= 3) > -1 && p.push(239, 191, 189);
              continue;
            }
            l = t;
            continue;
          }
          if (t < 56320) {
            (r -= 3) > -1 && p.push(239, 191, 189), l = t;
            continue;
          }
          t = (l - 55296 << 10 | t - 56320) + 65536;
        } else l && (r -= 3) > -1 && p.push(239, 191, 189);
        if (l = null, t < 128) {
          if ((r -= 1) < 0) break;
          p.push(t);
        } else if (t < 2048) {
          if ((r -= 2) < 0) break;
          p.push(
            t >> 6 | 192,
            t & 63 | 128
          );
        } else if (t < 65536) {
          if ((r -= 3) < 0) break;
          p.push(
            t >> 12 | 224,
            t >> 6 & 63 | 128,
            t & 63 | 128
          );
        } else if (t < 1114112) {
          if ((r -= 4) < 0) break;
          p.push(
            t >> 18 | 240,
            t >> 12 & 63 | 128,
            t >> 6 & 63 | 128,
            t & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return p;
    }
    function lt(o) {
      for (var r = [], t = 0; t < o.length; ++t)
        r.push(o.charCodeAt(t) & 255);
      return r;
    }
    function pt(o, r) {
      for (var t, u, l, p = [], y = 0; y < o.length && !((r -= 2) < 0); ++y)
        t = o.charCodeAt(y), u = t >> 8, l = t % 256, p.push(l), p.push(u);
      return p;
    }
    function xr(o) {
      return i.toByteArray(st(o));
    }
    function er(o, r, t, u) {
      for (var l = 0; l < u && !(l + t >= r.length || l >= o.length); ++l)
        r[l + t] = o[l];
      return l;
    }
    function yt(o) {
      return o !== o;
    }
  }(ur)), ur;
}
var Ve = dt(), N;
typeof window < "u" && window.crypto && (N = window.crypto);
!N && typeof window < "u" && window.msCrypto && (N = window.msCrypto);
!N && typeof globalThis < "u" && globalThis.crypto && (N = globalThis.crypto);
if (!N && typeof require == "function")
  try {
    N = require("crypto");
  } catch {
  }
function Ge() {
  if (N) {
    if (typeof N.getRandomValues == "function")
      try {
        return N.getRandomValues(new Uint32Array(1))[0];
      } catch {
      }
    if (typeof N.randomBytes == "function")
      try {
        return N.randomBytes(4).readInt32LE();
      } catch {
      }
  }
  throw new Error("Native crypto module could not be used to get secure random number.");
}
var ar = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var lr = function(e, i) {
  return lr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var h in a) a.hasOwnProperty(h) && (n[h] = a[h]);
  }, lr(e, i);
};
function gt(e, i) {
  lr(e, i);
  function n() {
    this.constructor = e;
  }
  e.prototype = i === null ? Object.create(i) : (n.prototype = i.prototype, new n());
}
var pr = function() {
  return pr = Object.assign || function(i) {
    for (var n, a = 1, h = arguments.length; a < h; a++) {
      n = arguments[a];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (i[s] = n[s]);
    }
    return i;
  }, pr.apply(this, arguments);
};
function _t(e, i) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && i.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var h = 0, a = Object.getOwnPropertySymbols(e); h < a.length; h++)
      i.indexOf(a[h]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[h]) && (n[a[h]] = e[a[h]]);
  return n;
}
function bt(e, i, n, a) {
  var h = arguments.length, s = h < 3 ? i : a === null ? a = Object.getOwnPropertyDescriptor(i, n) : a, c;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(e, i, n, a);
  else for (var f = e.length - 1; f >= 0; f--) (c = e[f]) && (s = (h < 3 ? c(s) : h > 3 ? c(i, n, s) : c(i, n)) || s);
  return h > 3 && s && Object.defineProperty(i, n, s), s;
}
function Et(e, i) {
  return function(n, a) {
    i(n, a, e);
  };
}
function Tt(e, i) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, i);
}
function At(e, i, n, a) {
  function h(s) {
    return s instanceof n ? s : new n(function(c) {
      c(s);
    });
  }
  return new (n || (n = Promise))(function(s, c) {
    function f(v) {
      try {
        w(a.next(v));
      } catch (b) {
        c(b);
      }
    }
    function m(v) {
      try {
        w(a.throw(v));
      } catch (b) {
        c(b);
      }
    }
    function w(v) {
      v.done ? s(v.value) : h(v.value).then(f, m);
    }
    w((a = a.apply(e, i || [])).next());
  });
}
function Bt(e, i) {
  var n = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, a, h, s, c;
  return c = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function f(w) {
    return function(v) {
      return m([w, v]);
    };
  }
  function m(w) {
    if (a) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (a = 1, h && (s = w[0] & 2 ? h.return : w[0] ? h.throw || ((s = h.return) && s.call(h), 0) : h.next) && !(s = s.call(h, w[1])).done) return s;
      switch (h = 0, s && (w = [w[0] & 2, s.value]), w[0]) {
        case 0:
        case 1:
          s = w;
          break;
        case 4:
          return n.label++, { value: w[1], done: !1 };
        case 5:
          n.label++, h = w[1], w = [0];
          continue;
        case 7:
          w = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (s = n.trys, !(s = s.length > 0 && s[s.length - 1]) && (w[0] === 6 || w[0] === 2)) {
            n = 0;
            continue;
          }
          if (w[0] === 3 && (!s || w[1] > s[0] && w[1] < s[3])) {
            n.label = w[1];
            break;
          }
          if (w[0] === 6 && n.label < s[1]) {
            n.label = s[1], s = w;
            break;
          }
          if (s && n.label < s[2]) {
            n.label = s[2], n.ops.push(w);
            break;
          }
          s[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      w = i.call(e, n);
    } catch (v) {
      w = [6, v], h = 0;
    } finally {
      a = s = 0;
    }
    if (w[0] & 5) throw w[1];
    return { value: w[0] ? w[1] : void 0, done: !0 };
  }
}
function xt(e, i, n, a) {
  a === void 0 && (a = n), e[a] = i[n];
}
function St(e, i) {
  for (var n in e) n !== "default" && !i.hasOwnProperty(n) && (i[n] = e[n]);
}
function yr(e) {
  var i = typeof Symbol == "function" && Symbol.iterator, n = i && e[i], a = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && a >= e.length && (e = void 0), { value: e && e[a++], done: !e };
    }
  };
  throw new TypeError(i ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Gr(e, i) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var a = n.call(e), h, s = [], c;
  try {
    for (; (i === void 0 || i-- > 0) && !(h = a.next()).done; ) s.push(h.value);
  } catch (f) {
    c = { error: f };
  } finally {
    try {
      h && !h.done && (n = a.return) && n.call(a);
    } finally {
      if (c) throw c.error;
    }
  }
  return s;
}
function Rt() {
  for (var e = [], i = 0; i < arguments.length; i++)
    e = e.concat(Gr(arguments[i]));
  return e;
}
function It() {
  for (var e = 0, i = 0, n = arguments.length; i < n; i++) e += arguments[i].length;
  for (var a = Array(e), h = 0, i = 0; i < n; i++)
    for (var s = arguments[i], c = 0, f = s.length; c < f; c++, h++)
      a[h] = s[c];
  return a;
}
function z(e) {
  return this instanceof z ? (this.v = e, this) : new z(e);
}
function Ut(e, i, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = n.apply(e, i || []), h, s = [];
  return h = {}, c("next"), c("throw"), c("return"), h[Symbol.asyncIterator] = function() {
    return this;
  }, h;
  function c(E) {
    a[E] && (h[E] = function(d) {
      return new Promise(function(g, _) {
        s.push([E, d, g, _]) > 1 || f(E, d);
      });
    });
  }
  function f(E, d) {
    try {
      m(a[E](d));
    } catch (g) {
      b(s[0][3], g);
    }
  }
  function m(E) {
    E.value instanceof z ? Promise.resolve(E.value.v).then(w, v) : b(s[0][2], E);
  }
  function w(E) {
    f("next", E);
  }
  function v(E) {
    f("throw", E);
  }
  function b(E, d) {
    E(d), s.shift(), s.length && f(s[0][0], s[0][1]);
  }
}
function Dt(e) {
  var i, n;
  return i = {}, a("next"), a("throw", function(h) {
    throw h;
  }), a("return"), i[Symbol.iterator] = function() {
    return this;
  }, i;
  function a(h, s) {
    i[h] = e[h] ? function(c) {
      return (n = !n) ? { value: z(e[h](c)), done: h === "return" } : s ? s(c) : c;
    } : s;
  }
}
function Ct(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = e[Symbol.asyncIterator], n;
  return i ? i.call(e) : (e = typeof yr == "function" ? yr(e) : e[Symbol.iterator](), n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function a(s) {
    n[s] = e[s] && function(c) {
      return new Promise(function(f, m) {
        c = e[s](c), h(f, m, c.done, c.value);
      });
    };
  }
  function h(s, c, f, m) {
    Promise.resolve(m).then(function(w) {
      s({ value: w, done: f });
    }, c);
  }
}
function Pt(e, i) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: i }) : e.raw = i, e;
}
function Mt(e) {
  if (e && e.__esModule) return e;
  var i = {};
  if (e != null)
    for (var n in e) Object.hasOwnProperty.call(e, n) && (i[n] = e[n]);
  return i.default = e, i;
}
function Ot(e) {
  return e && e.__esModule ? e : { default: e };
}
function Lt(e, i) {
  if (!i.has(e))
    throw new TypeError("attempted to get private field on non-instance");
  return i.get(e);
}
function Ft(e, i, n) {
  if (!i.has(e))
    throw new TypeError("attempted to set private field on non-instance");
  return i.set(e, n), n;
}
const Yt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return pr;
  },
  __asyncDelegator: Dt,
  __asyncGenerator: Ut,
  __asyncValues: Ct,
  __await: z,
  __awaiter: At,
  __classPrivateFieldGet: Lt,
  __classPrivateFieldSet: Ft,
  __createBinding: xt,
  __decorate: bt,
  __exportStar: St,
  __extends: gt,
  __generator: Bt,
  __importDefault: Ot,
  __importStar: Mt,
  __makeTemplateObject: Pt,
  __metadata: Tt,
  __param: Et,
  __read: Gr,
  __rest: _t,
  __spread: Rt,
  __spreadArrays: It,
  __values: yr
}, Symbol.toStringTag, { value: "Module" })), Jr = /* @__PURE__ */ wr(Yt);
var K = {}, Y = {}, Pr;
function Wr() {
  return Pr || (Pr = 1, Object.defineProperty(Y, "__esModule", { value: !0 }), Y.MAX_HASHABLE_LENGTH = Y.INIT = Y.KEY = Y.DIGEST_LENGTH = Y.BLOCK_SIZE = void 0, Y.BLOCK_SIZE = 64, Y.DIGEST_LENGTH = 32, Y.KEY = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]), Y.INIT = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], Y.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1), Y;
}
var V = {}, Mr;
function Nt() {
  if (Mr) return V;
  Mr = 1, Object.defineProperty(V, "__esModule", { value: !0 }), V.RawSha256 = void 0;
  var e = Wr(), i = (
    /** @class */
    function() {
      function n() {
        this.state = Int32Array.from(e.INIT), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
      }
      return n.prototype.update = function(a) {
        if (this.finished)
          throw new Error("Attempted to update an already finished hash.");
        var h = 0, s = a.byteLength;
        if (this.bytesHashed += s, this.bytesHashed * 8 > e.MAX_HASHABLE_LENGTH)
          throw new Error("Cannot hash more than 2^53 - 1 bits");
        for (; s > 0; )
          this.buffer[this.bufferLength++] = a[h++], s--, this.bufferLength === e.BLOCK_SIZE && (this.hashBuffer(), this.bufferLength = 0);
      }, n.prototype.digest = function() {
        if (!this.finished) {
          var a = this.bytesHashed * 8, h = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), s = this.bufferLength;
          if (h.setUint8(this.bufferLength++, 128), s % e.BLOCK_SIZE >= e.BLOCK_SIZE - 8) {
            for (var c = this.bufferLength; c < e.BLOCK_SIZE; c++)
              h.setUint8(c, 0);
            this.hashBuffer(), this.bufferLength = 0;
          }
          for (var c = this.bufferLength; c < e.BLOCK_SIZE - 8; c++)
            h.setUint8(c, 0);
          h.setUint32(e.BLOCK_SIZE - 8, Math.floor(a / 4294967296), !0), h.setUint32(e.BLOCK_SIZE - 4, a), this.hashBuffer(), this.finished = !0;
        }
        for (var f = new Uint8Array(e.DIGEST_LENGTH), c = 0; c < 8; c++)
          f[c * 4] = this.state[c] >>> 24 & 255, f[c * 4 + 1] = this.state[c] >>> 16 & 255, f[c * 4 + 2] = this.state[c] >>> 8 & 255, f[c * 4 + 3] = this.state[c] >>> 0 & 255;
        return f;
      }, n.prototype.hashBuffer = function() {
        for (var a = this, h = a.buffer, s = a.state, c = s[0], f = s[1], m = s[2], w = s[3], v = s[4], b = s[5], E = s[6], d = s[7], g = 0; g < e.BLOCK_SIZE; g++) {
          if (g < 16)
            this.temp[g] = (h[g * 4] & 255) << 24 | (h[g * 4 + 1] & 255) << 16 | (h[g * 4 + 2] & 255) << 8 | h[g * 4 + 3] & 255;
          else {
            var _ = this.temp[g - 2], A = (_ >>> 17 | _ << 15) ^ (_ >>> 19 | _ << 13) ^ _ >>> 10;
            _ = this.temp[g - 15];
            var x = (_ >>> 7 | _ << 25) ^ (_ >>> 18 | _ << 14) ^ _ >>> 3;
            this.temp[g] = (A + this.temp[g - 7] | 0) + (x + this.temp[g - 16] | 0);
          }
          var S = (((v >>> 6 | v << 26) ^ (v >>> 11 | v << 21) ^ (v >>> 25 | v << 7)) + (v & b ^ ~v & E) | 0) + (d + (e.KEY[g] + this.temp[g] | 0) | 0) | 0, C = ((c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10)) + (c & f ^ c & m ^ f & m) | 0;
          d = E, E = b, b = v, v = w + S | 0, w = m, m = f, f = c, c = S + C | 0;
        }
        s[0] += c, s[1] += f, s[2] += m, s[3] += w, s[4] += v, s[5] += b, s[6] += E, s[7] += d;
      }, n;
    }()
  );
  return V.RawSha256 = i, V;
}
var sr = {}, G = {};
const qt = (e) => {
  const i = [];
  for (let n = 0, a = e.length; n < a; n++) {
    const h = e.charCodeAt(n);
    if (h < 128)
      i.push(h);
    else if (h < 2048)
      i.push(h >> 6 | 192, h & 63 | 128);
    else if (n + 1 < e.length && (h & 64512) === 55296 && (e.charCodeAt(n + 1) & 64512) === 56320) {
      const s = 65536 + ((h & 1023) << 10) + (e.charCodeAt(++n) & 1023);
      i.push(s >> 18 | 240, s >> 12 & 63 | 128, s >> 6 & 63 | 128, s & 63 | 128);
    } else
      i.push(h >> 12 | 224, h >> 6 & 63 | 128, h & 63 | 128);
  }
  return Uint8Array.from(i);
}, jt = (e) => {
  let i = "";
  for (let n = 0, a = e.length; n < a; n++) {
    const h = e[n];
    if (h < 128)
      i += String.fromCharCode(h);
    else if (192 <= h && h < 224) {
      const s = e[++n];
      i += String.fromCharCode((h & 31) << 6 | s & 63);
    } else if (240 <= h && h < 365) {
      const c = "%" + [h, e[++n], e[++n], e[++n]].map((f) => f.toString(16)).join("%");
      i += decodeURIComponent(c);
    } else
      i += String.fromCharCode((h & 15) << 12 | (e[++n] & 63) << 6 | e[++n] & 63);
  }
  return i;
};
function kt(e) {
  return new TextEncoder().encode(e);
}
function Zt(e) {
  return new TextDecoder("utf-8").decode(e);
}
const $t = (e) => typeof TextEncoder == "function" ? kt(e) : qt(e), Ht = (e) => typeof TextDecoder == "function" ? Zt(e) : jt(e), Kt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fromUtf8: $t,
  toUtf8: Ht
}, Symbol.toStringTag, { value: "Module" })), Vt = /* @__PURE__ */ wr(Kt);
var Or;
function Gt() {
  if (Or) return G;
  Or = 1, Object.defineProperty(G, "__esModule", { value: !0 }), G.convertToBuffer = void 0;
  var e = Vt, i = typeof Buffer < "u" && Buffer.from ? function(a) {
    return Buffer.from(a, "utf8");
  } : e.fromUtf8;
  function n(a) {
    return a instanceof Uint8Array ? a : typeof a == "string" ? i(a) : ArrayBuffer.isView(a) ? new Uint8Array(a.buffer, a.byteOffset, a.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(a);
  }
  return G.convertToBuffer = n, G;
}
var J = {}, Lr;
function Jt() {
  if (Lr) return J;
  Lr = 1, Object.defineProperty(J, "__esModule", { value: !0 }), J.isEmptyData = void 0;
  function e(i) {
    return typeof i == "string" ? i.length === 0 : i.byteLength === 0;
  }
  return J.isEmptyData = e, J;
}
var W = {}, Fr;
function Wt() {
  if (Fr) return W;
  Fr = 1, Object.defineProperty(W, "__esModule", { value: !0 }), W.numToUint8 = void 0;
  function e(i) {
    return new Uint8Array([
      (i & 4278190080) >> 24,
      (i & 16711680) >> 16,
      (i & 65280) >> 8,
      i & 255
    ]);
  }
  return W.numToUint8 = e, W;
}
var X = {}, Yr;
function Xt() {
  if (Yr) return X;
  Yr = 1, Object.defineProperty(X, "__esModule", { value: !0 }), X.uint32ArrayFrom = void 0;
  function e(i) {
    if (!Array.from) {
      for (var n = new Uint32Array(i.length), a = 0; a < i.length; )
        n[a] = i[a];
      return n;
    }
    return Uint32Array.from(i);
  }
  return X.uint32ArrayFrom = e, X;
}
var Nr;
function zt() {
  return Nr || (Nr = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.uint32ArrayFrom = e.numToUint8 = e.isEmptyData = e.convertToBuffer = void 0;
    var i = Gt();
    Object.defineProperty(e, "convertToBuffer", { enumerable: !0, get: function() {
      return i.convertToBuffer;
    } });
    var n = Jt();
    Object.defineProperty(e, "isEmptyData", { enumerable: !0, get: function() {
      return n.isEmptyData;
    } });
    var a = Wt();
    Object.defineProperty(e, "numToUint8", { enumerable: !0, get: function() {
      return a.numToUint8;
    } });
    var h = Xt();
    Object.defineProperty(e, "uint32ArrayFrom", { enumerable: !0, get: function() {
      return h.uint32ArrayFrom;
    } });
  }(sr)), sr;
}
var qr;
function Qt() {
  if (qr) return K;
  qr = 1, Object.defineProperty(K, "__esModule", { value: !0 }), K.Sha256 = void 0;
  var e = Jr, i = Wr(), n = Nt(), a = zt(), h = (
    /** @class */
    function() {
      function c(f) {
        if (this.hash = new n.RawSha256(), f) {
          this.outer = new n.RawSha256();
          var m = s(f), w = new Uint8Array(i.BLOCK_SIZE);
          w.set(m);
          for (var v = 0; v < i.BLOCK_SIZE; v++)
            m[v] ^= 54, w[v] ^= 92;
          this.hash.update(m), this.outer.update(w);
          for (var v = 0; v < m.byteLength; v++)
            m[v] = 0;
        }
      }
      return c.prototype.update = function(f) {
        if (!((0, a.isEmptyData)(f) || this.error))
          try {
            this.hash.update((0, a.convertToBuffer)(f));
          } catch (m) {
            this.error = m;
          }
      }, c.prototype.digestSync = function() {
        if (this.error)
          throw this.error;
        return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest();
      }, c.prototype.digest = function() {
        return (0, e.__awaiter)(this, void 0, void 0, function() {
          return (0, e.__generator)(this, function(f) {
            return [2, this.digestSync()];
          });
        });
      }, c;
    }()
  );
  K.Sha256 = h;
  function s(c) {
    var f = (0, a.convertToBuffer)(c);
    if (f.byteLength > i.BLOCK_SIZE) {
      var m = new n.RawSha256();
      m.update(f), f = m.digest();
    }
    var w = new Uint8Array(i.BLOCK_SIZE);
    return w.set(f), w;
  }
  return K;
}
var jr;
function re() {
  return jr || (jr = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var i = Jr;
    (0, i.__exportStar)(Qt(), e);
  }(ar)), ar;
}
var Je = re();
function T(e, i) {
  e != null && this.fromString(e, i);
}
function O() {
  return new T(null);
}
var j, te = 244837814094590, kr = (te & 16777215) == 15715070;
function ee(e, i, n, a, h, s) {
  for (; --s >= 0; ) {
    var c = i * this[e++] + n[a] + h;
    h = Math.floor(c / 67108864), n[a++] = c & 67108863;
  }
  return h;
}
function ie(e, i, n, a, h, s) {
  for (var c = i & 32767, f = i >> 15; --s >= 0; ) {
    var m = this[e] & 32767, w = this[e++] >> 15, v = f * m + w * c;
    m = c * m + ((v & 32767) << 15) + n[a] + (h & 1073741823), h = (m >>> 30) + (v >>> 15) + f * w + (h >>> 30), n[a++] = m & 1073741823;
  }
  return h;
}
function ne(e, i, n, a, h, s) {
  for (var c = i & 16383, f = i >> 14; --s >= 0; ) {
    var m = this[e] & 16383, w = this[e++] >> 14, v = f * m + w * c;
    m = c * m + ((v & 16383) << 14) + n[a] + h, h = (m >> 28) + (v >> 14) + f * w, n[a++] = m & 268435455;
  }
  return h;
}
var Zr = typeof navigator < "u";
Zr && kr && navigator.appName == "Microsoft Internet Explorer" ? (T.prototype.am = ie, j = 30) : Zr && kr && navigator.appName != "Netscape" ? (T.prototype.am = ee, j = 26) : (T.prototype.am = ne, j = 28);
T.prototype.DB = j;
T.prototype.DM = (1 << j) - 1;
T.prototype.DV = 1 << j;
var vr = 52;
T.prototype.FV = Math.pow(2, vr);
T.prototype.F1 = vr - j;
T.prototype.F2 = 2 * j - vr;
var oe = "0123456789abcdefghijklmnopqrstuvwxyz", or = new Array(), Z, q;
Z = 48;
for (q = 0; q <= 9; ++q) or[Z++] = q;
Z = 97;
for (q = 10; q < 36; ++q) or[Z++] = q;
Z = 65;
for (q = 10; q < 36; ++q) or[Z++] = q;
function $r(e) {
  return oe.charAt(e);
}
function ue(e, i) {
  var n = or[e.charCodeAt(i)];
  return n ?? -1;
}
function fe(e) {
  for (var i = this.t - 1; i >= 0; --i) e[i] = this[i];
  e.t = this.t, e.s = this.s;
}
function ae(e) {
  this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this[0] = e : e < -1 ? this[0] = e + this.DV : this.t = 0;
}
function mr(e) {
  var i = O();
  return i.fromInt(e), i;
}
function se(e, i) {
  var n;
  if (i == 16) n = 4;
  else if (i == 8) n = 3;
  else if (i == 2) n = 1;
  else if (i == 32) n = 5;
  else if (i == 4) n = 2;
  else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  this.t = 0, this.s = 0;
  for (var a = e.length, h = !1, s = 0; --a >= 0; ) {
    var c = ue(e, a);
    if (c < 0) {
      e.charAt(a) == "-" && (h = !0);
      continue;
    }
    h = !1, s == 0 ? this[this.t++] = c : s + n > this.DB ? (this[this.t - 1] |= (c & (1 << this.DB - s) - 1) << s, this[this.t++] = c >> this.DB - s) : this[this.t - 1] |= c << s, s += n, s >= this.DB && (s -= this.DB);
  }
  this.clamp(), h && T.ZERO.subTo(this, this);
}
function he() {
  for (var e = this.s & this.DM; this.t > 0 && this[this.t - 1] == e; ) --this.t;
}
function ce(e) {
  if (this.s < 0) return "-" + this.negate().toString(e);
  var i;
  if (e == 16) i = 4;
  else if (e == 8) i = 3;
  else if (e == 2) i = 1;
  else if (e == 32) i = 5;
  else if (e == 4) i = 2;
  else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  var n = (1 << i) - 1, a, h = !1, s = "", c = this.t, f = this.DB - c * this.DB % i;
  if (c-- > 0)
    for (f < this.DB && (a = this[c] >> f) > 0 && (h = !0, s = $r(a)); c >= 0; )
      f < i ? (a = (this[c] & (1 << f) - 1) << i - f, a |= this[--c] >> (f += this.DB - i)) : (a = this[c] >> (f -= i) & n, f <= 0 && (f += this.DB, --c)), a > 0 && (h = !0), h && (s += $r(a));
  return h ? s : "0";
}
function le() {
  var e = O();
  return T.ZERO.subTo(this, e), e;
}
function pe() {
  return this.s < 0 ? this.negate() : this;
}
function ye(e) {
  var i = this.s - e.s;
  if (i != 0) return i;
  var n = this.t;
  if (i = n - e.t, i != 0) return this.s < 0 ? -i : i;
  for (; --n >= 0; ) if ((i = this[n] - e[n]) != 0) return i;
  return 0;
}
function dr(e) {
  var i = 1, n;
  return (n = e >>> 16) != 0 && (e = n, i += 16), (n = e >> 8) != 0 && (e = n, i += 8), (n = e >> 4) != 0 && (e = n, i += 4), (n = e >> 2) != 0 && (e = n, i += 2), (n = e >> 1) != 0 && (e = n, i += 1), i;
}
function we() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + dr(this[this.t - 1] ^ this.s & this.DM);
}
function ve(e, i) {
  var n;
  for (n = this.t - 1; n >= 0; --n) i[n + e] = this[n];
  for (n = e - 1; n >= 0; --n) i[n] = 0;
  i.t = this.t + e, i.s = this.s;
}
function me(e, i) {
  for (var n = e; n < this.t; ++n) i[n - e] = this[n];
  i.t = Math.max(this.t - e, 0), i.s = this.s;
}
function de(e, i) {
  var n = e % this.DB, a = this.DB - n, h = (1 << a) - 1, s = Math.floor(e / this.DB), c = this.s << n & this.DM, f;
  for (f = this.t - 1; f >= 0; --f)
    i[f + s + 1] = this[f] >> a | c, c = (this[f] & h) << n;
  for (f = s - 1; f >= 0; --f) i[f] = 0;
  i[s] = c, i.t = this.t + s + 1, i.s = this.s, i.clamp();
}
function ge(e, i) {
  i.s = this.s;
  var n = Math.floor(e / this.DB);
  if (n >= this.t) {
    i.t = 0;
    return;
  }
  var a = e % this.DB, h = this.DB - a, s = (1 << a) - 1;
  i[0] = this[n] >> a;
  for (var c = n + 1; c < this.t; ++c)
    i[c - n - 1] |= (this[c] & s) << h, i[c - n] = this[c] >> a;
  a > 0 && (i[this.t - n - 1] |= (this.s & s) << h), i.t = this.t - n, i.clamp();
}
function _e(e, i) {
  for (var n = 0, a = 0, h = Math.min(e.t, this.t); n < h; )
    a += this[n] - e[n], i[n++] = a & this.DM, a >>= this.DB;
  if (e.t < this.t) {
    for (a -= e.s; n < this.t; )
      a += this[n], i[n++] = a & this.DM, a >>= this.DB;
    a += this.s;
  } else {
    for (a += this.s; n < e.t; )
      a -= e[n], i[n++] = a & this.DM, a >>= this.DB;
    a -= e.s;
  }
  i.s = a < 0 ? -1 : 0, a < -1 ? i[n++] = this.DV + a : a > 0 && (i[n++] = a), i.t = n, i.clamp();
}
function be(e, i) {
  var n = this.abs(), a = e.abs(), h = n.t;
  for (i.t = h + a.t; --h >= 0; ) i[h] = 0;
  for (h = 0; h < a.t; ++h) i[h + n.t] = n.am(0, a[h], i, h, 0, n.t);
  i.s = 0, i.clamp(), this.s != e.s && T.ZERO.subTo(i, i);
}
function Ee(e) {
  for (var i = this.abs(), n = e.t = 2 * i.t; --n >= 0; ) e[n] = 0;
  for (n = 0; n < i.t - 1; ++n) {
    var a = i.am(n, i[n], e, 2 * n, 0, 1);
    (e[n + i.t] += i.am(n + 1, 2 * i[n], e, 2 * n + 1, a, i.t - n - 1)) >= i.DV && (e[n + i.t] -= i.DV, e[n + i.t + 1] = 1);
  }
  e.t > 0 && (e[e.t - 1] += i.am(n, i[n], e, 2 * n, 0, 1)), e.s = 0, e.clamp();
}
function Te(e, i, n) {
  var a = e.abs();
  if (!(a.t <= 0)) {
    var h = this.abs();
    if (h.t < a.t) {
      i != null && i.fromInt(0), n != null && this.copyTo(n);
      return;
    }
    n == null && (n = O());
    var s = O(), c = this.s, f = e.s, m = this.DB - dr(a[a.t - 1]);
    m > 0 ? (a.lShiftTo(m, s), h.lShiftTo(m, n)) : (a.copyTo(s), h.copyTo(n));
    var w = s.t, v = s[w - 1];
    if (v != 0) {
      var b = v * (1 << this.F1) + (w > 1 ? s[w - 2] >> this.F2 : 0), E = this.FV / b, d = (1 << this.F1) / b, g = 1 << this.F2, _ = n.t, A = _ - w, x = i ?? O();
      for (s.dlShiftTo(A, x), n.compareTo(x) >= 0 && (n[n.t++] = 1, n.subTo(x, n)), T.ONE.dlShiftTo(w, x), x.subTo(s, s); s.t < w; ) s[s.t++] = 0;
      for (; --A >= 0; ) {
        var S = n[--_] == v ? this.DM : Math.floor(n[_] * E + (n[_ - 1] + g) * d);
        if ((n[_] += s.am(0, S, n, A, 0, w)) < S)
          for (s.dlShiftTo(A, x), n.subTo(x, n); n[_] < --S; ) n.subTo(x, n);
      }
      i != null && (n.drShiftTo(w, i), c != f && T.ZERO.subTo(i, i)), n.t = w, n.clamp(), m > 0 && n.rShiftTo(m, n), c < 0 && T.ZERO.subTo(n, n);
    }
  }
}
function Ae(e) {
  var i = O();
  return this.abs().divRemTo(e, null, i), this.s < 0 && i.compareTo(T.ZERO) > 0 && e.subTo(i, i), i;
}
function Be() {
  if (this.t < 1) return 0;
  var e = this[0];
  if ((e & 1) == 0) return 0;
  var i = e & 3;
  return i = i * (2 - (e & 15) * i) & 15, i = i * (2 - (e & 255) * i) & 255, i = i * (2 - ((e & 65535) * i & 65535)) & 65535, i = i * (2 - e * i % this.DV) % this.DV, i > 0 ? this.DV - i : -i;
}
function xe(e) {
  return this.compareTo(e) == 0;
}
function Se(e, i) {
  for (var n = 0, a = 0, h = Math.min(e.t, this.t); n < h; )
    a += this[n] + e[n], i[n++] = a & this.DM, a >>= this.DB;
  if (e.t < this.t) {
    for (a += e.s; n < this.t; )
      a += this[n], i[n++] = a & this.DM, a >>= this.DB;
    a += this.s;
  } else {
    for (a += this.s; n < e.t; )
      a += e[n], i[n++] = a & this.DM, a >>= this.DB;
    a += e.s;
  }
  i.s = a < 0 ? -1 : 0, a > 0 ? i[n++] = a : a < -1 && (i[n++] = this.DV + a), i.t = n, i.clamp();
}
function Re(e) {
  var i = O();
  return this.addTo(e, i), i;
}
function Ie(e) {
  var i = O();
  return this.subTo(e, i), i;
}
function Ue(e) {
  var i = O();
  return this.multiplyTo(e, i), i;
}
function De(e) {
  var i = O();
  return this.divRemTo(e, i, null), i;
}
function $(e) {
  this.m = e, this.mp = e.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
}
function Ce(e) {
  var i = O();
  return e.abs().dlShiftTo(this.m.t, i), i.divRemTo(this.m, null, i), e.s < 0 && i.compareTo(T.ZERO) > 0 && this.m.subTo(i, i), i;
}
function Pe(e) {
  var i = O();
  return e.copyTo(i), this.reduce(i), i;
}
function Me(e) {
  for (; e.t <= this.mt2; )
    e[e.t++] = 0;
  for (var i = 0; i < this.m.t; ++i) {
    var n = e[i] & 32767, a = n * this.mpl + ((n * this.mph + (e[i] >> 15) * this.mpl & this.um) << 15) & e.DM;
    for (n = i + this.m.t, e[n] += this.m.am(0, a, e, i, 0, this.m.t); e[n] >= e.DV; )
      e[n] -= e.DV, e[++n]++;
  }
  e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
}
function Oe(e, i) {
  e.squareTo(i), this.reduce(i);
}
function Le(e, i, n) {
  e.multiplyTo(i, n), this.reduce(n);
}
$.prototype.convert = Ce;
$.prototype.revert = Pe;
$.prototype.reduce = Me;
$.prototype.mulTo = Le;
$.prototype.sqrTo = Oe;
function Fe(e, i, n) {
  var a = e.bitLength(), h, s = mr(1), c = new $(i);
  if (a <= 0) return s;
  a < 18 ? h = 1 : a < 48 ? h = 3 : a < 144 ? h = 4 : a < 768 ? h = 5 : h = 6;
  var f = new Array(), m = 3, w = h - 1, v = (1 << h) - 1;
  if (f[1] = c.convert(this), h > 1) {
    var b = O();
    for (c.sqrTo(f[1], b); m <= v; )
      f[m] = O(), c.mulTo(b, f[m - 2], f[m]), m += 2;
  }
  var E = e.t - 1, d, g = !0, _ = O(), A;
  for (a = dr(e[E]) - 1; E >= 0; ) {
    for (a >= w ? d = e[E] >> a - w & v : (d = (e[E] & (1 << a + 1) - 1) << w - a, E > 0 && (d |= e[E - 1] >> this.DB + a - w)), m = h; (d & 1) == 0; )
      d >>= 1, --m;
    if ((a -= m) < 0 && (a += this.DB, --E), g)
      f[d].copyTo(s), g = !1;
    else {
      for (; m > 1; )
        c.sqrTo(s, _), c.sqrTo(_, s), m -= 2;
      m > 0 ? c.sqrTo(s, _) : (A = s, s = _, _ = A), c.mulTo(_, f[d], s);
    }
    for (; E >= 0 && (e[E] & 1 << a) == 0; )
      c.sqrTo(s, _), A = s, s = _, _ = A, --a < 0 && (a = this.DB - 1, --E);
  }
  var x = c.revert(s);
  return n(null, x), x;
}
T.prototype.copyTo = fe;
T.prototype.fromInt = ae;
T.prototype.fromString = se;
T.prototype.clamp = he;
T.prototype.dlShiftTo = ve;
T.prototype.drShiftTo = me;
T.prototype.lShiftTo = de;
T.prototype.rShiftTo = ge;
T.prototype.subTo = _e;
T.prototype.multiplyTo = be;
T.prototype.squareTo = Ee;
T.prototype.divRemTo = Te;
T.prototype.invDigit = Be;
T.prototype.addTo = Se;
T.prototype.toString = ce;
T.prototype.negate = le;
T.prototype.abs = pe;
T.prototype.compareTo = ye;
T.prototype.bitLength = we;
T.prototype.mod = Ae;
T.prototype.equals = xe;
T.prototype.add = Re;
T.prototype.subtract = Ie;
T.prototype.multiply = Ue;
T.prototype.divide = De;
T.prototype.modPow = Fe;
T.ZERO = mr(0);
T.ONE = mr(1);
var Ye = "5.0.4";
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Ne = "aws-amplify/" + Ye, qe = {
  userAgent: Ne,
  isReactNative: typeof navigator < "u" && navigator.product === "ReactNative"
}, je = function() {
  return qe.userAgent;
};
function ke(e, i) {
  return i = i || {}, new Promise(function(n, a) {
    var h = new XMLHttpRequest(), s = [], c = [], f = {}, m = function() {
      return { ok: (h.status / 100 | 0) == 2, statusText: h.statusText, status: h.status, url: h.responseURL, text: function() {
        return Promise.resolve(h.responseText);
      }, json: function() {
        return Promise.resolve(h.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([h.response]));
      }, clone: m, headers: { keys: function() {
        return s;
      }, entries: function() {
        return c;
      }, get: function(v) {
        return f[v.toLowerCase()];
      }, has: function(v) {
        return v.toLowerCase() in f;
      } } };
    };
    for (var w in h.open(i.method || "get", e, !0), h.onload = function() {
      h.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(v, b, E) {
        s.push(b = b.toLowerCase()), c.push([b, E]), f[b] = f[b] ? f[b] + "," + E : E;
      }), n(m());
    }, h.onerror = a, h.withCredentials = i.credentials == "include", i.headers) h.setRequestHeader(w, i.headers[w]);
    h.send(i.body || null);
  });
}
const Ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ke
}, Symbol.toStringTag, { value: "Module" })), Hr = /* @__PURE__ */ wr(Ze);
var hr, Kr;
function $e() {
  return Kr || (Kr = 1, hr = self.fetch || (self.fetch = Hr.default || Hr)), hr;
}
$e();
function k() {
}
k.prototype.userAgent = je();
var We = function(i) {
  var n = k.category ? " " + k.category : "", a = k.framework ? " framework/" + k.framework : "", h = "" + k.prototype.userAgent + n + a;
  return h;
}, cr = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
var Vr;
function He() {
  return Vr || (Vr = 1, function(e, i) {
    (function(n) {
      var a;
      if (e.exports = n(), a = !0, !a) {
        var h = window.Cookies, s = window.Cookies = n();
        s.noConflict = function() {
          return window.Cookies = h, s;
        };
      }
    })(function() {
      function n() {
        for (var s = 0, c = {}; s < arguments.length; s++) {
          var f = arguments[s];
          for (var m in f)
            c[m] = f[m];
        }
        return c;
      }
      function a(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      function h(s) {
        function c() {
        }
        function f(w, v, b) {
          if (!(typeof document > "u")) {
            b = n({
              path: "/"
            }, c.defaults, b), typeof b.expires == "number" && (b.expires = new Date(/* @__PURE__ */ new Date() * 1 + b.expires * 864e5)), b.expires = b.expires ? b.expires.toUTCString() : "";
            try {
              var E = JSON.stringify(v);
              /^[\{\[]/.test(E) && (v = E);
            } catch {
            }
            v = s.write ? s.write(v, w) : encodeURIComponent(String(v)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), w = encodeURIComponent(String(w)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var d = "";
            for (var g in b)
              b[g] && (d += "; " + g, b[g] !== !0 && (d += "=" + b[g].split(";")[0]));
            return document.cookie = w + "=" + v + d;
          }
        }
        function m(w, v) {
          if (!(typeof document > "u")) {
            for (var b = {}, E = document.cookie ? document.cookie.split("; ") : [], d = 0; d < E.length; d++) {
              var g = E[d].split("="), _ = g.slice(1).join("=");
              !v && _.charAt(0) === '"' && (_ = _.slice(1, -1));
              try {
                var A = a(g[0]);
                if (_ = (s.read || s)(_, A) || a(_), v)
                  try {
                    _ = JSON.parse(_);
                  } catch {
                  }
                if (b[A] = _, w === A)
                  break;
              } catch {
              }
            }
            return w ? b[w] : b;
          }
        }
        return c.set = f, c.get = function(w) {
          return m(
            w,
            !1
            /* read as raw */
          );
        }, c.getJSON = function(w) {
          return m(
            w,
            !0
            /* read as json */
          );
        }, c.remove = function(w, v) {
          f(w, "", n(v, {
            expires: -1
          }));
        }, c.defaults = {}, c.withConverter = h, c;
      }
      return h(function() {
      });
    });
  }(cr)), cr.exports;
}
He();
export {
  T as B,
  qe as P,
  Je as a,
  Ve as b,
  Ge as c,
  We as g
};
